module.exports = __webpack_public_path__ + "static/MicrosoftPartner-325947a349081ab3ecec24cabcbe487c.png";